import { defineStore } from 'pinia'
import { ref } from 'vue'
import { ViewName } from '@/types'

export const useContextStore = defineStore('ContextStore', () => {
  const viewName = ref<ViewName>()
  const isLoading = ref<boolean>(false)

  const setViewName = (viewContextName: ViewName) => {
    viewName.value = viewContextName
  }

  return {
    isLoading,
    setViewName,
    viewName
  }
})
